/**
 * App Router
 *
 * Main application routing configuration.
 * Uses RouteRenderer with declarative route configuration.
 */

import RouteRenderer from '@/navigation/components/route-renderer';
import { appRouteConfig } from '@/navigation/routes/app-routes.config';

/**
 * AppRouter component
 *
 * Renders the application routes using RouteRenderer.
 */
export const AppRouter = () => {
  return <RouteRenderer config={appRouteConfig} />;
};
